import { mode } from '@chakra-ui/theme-tools'
// oxlint-disable-next-line typescript/no-explicit-any
type Dict = Record<string, any>

const baseStyleList = (props: Dict): Dict => {
  return {
    boxShadow: mode('lg', 'dark-lg')(props),
    borderColor: 'greys.200',
  }
}

export default {
  parts: ['groupTitle'],
  baseStyle: (props: Dict): Dict => ({
    groupTitle: {
      color: 'textMuted',
    },
    list: baseStyleList(props),
  }),
}
